import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type EnrollmentFunnelMetric = 'enrolledMembers' | 'activeMembers';

/**
 * `barsMetrics` claims a source's whole `bars` form, so it stays off
 * `campaign-members`, which also serves a breakdown-axis bars chart.
 */
const config: CampaignSourceConfig<EnrollmentFunnelMetric> = {
    label: 'Campaign enrollment funnel',
    endpoint: 'analytics/campaign-members-member',
    metrics: [
        { id: 'enrolledMembers', label: 'Enrolled members', type: 'scalar' },
        { id: 'activeMembers', label: 'Active members', type: 'scalar' },
    ],
    forms: ['bars'],
    barsMetrics: [
        { label: 'Fully enrolled', metricId: 'enrolledMembers' },
        { label: 'Made a qualifying purchase', metricId: 'activeMembers' },
    ],
    barsBaseMetricId: 'enrolledMembers',
    // enrolledMembers/activeMembers only nest on the campaign-to-date window.
    alwaysCampaignToDate: true,
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
};

export const campaignEnrollmentFunnelSource = withCampaignWindows(
    createEnvelopeSource(config),
    config
);
